<template>
  <aside class="spatial-development-framework-page">
    <DocumentPageTitle
      :word-count="totalWords"
      :word-limit="wordLimit"
      title="Spatial Development Framework"
    />

    <div
      v-for="storeItem in storeItems"
      :key="storeItem.id"
      class="mb-8"
    >
      <TextEditorInput
        :id="storeItem.id"
        v-model="planContentKey[storeItem.storeKey].text"
        :label="storeItem.label"
        :word-limit="wordLimit"
        :total-word-count="totalWords"
        @update:word-count="handleWordCountUpdate"
      />

      <DocumentAnnexureUploadButton :store-key="`spatialDevelopmentFramework.${storeItem.storeKey}.documents`" />
    </div>
  </aside>
</template>

<script setup>
import { usePlanStore } from '@/store';
import { DocumentPageTitle } from '@/components/plan-document/components';
import { TextEditorInput } from '@/components/form-inputs';
import { useString, useTinyMCEWordCount } from '@/composables';
import { DocumentAnnexureUploadButton } from '@/components/plan-document/components';
import { computed } from 'vue';

const planStore = usePlanStore();
const string = useString();

const wordLimit = 6000;

const planContentKey = computed(() => {
  return planStore.content?.spatialDevelopmentFramework || null;
});

const storeItems = [
  { label: 'Spatial, economic and development rationale', storeKey: 'spatialEconomicAndDevelopmentRationale' },
  { label: 'Desired spatial outcome', storeKey: 'desiredSpatialOutcome' },
  { label: 'Spatial strategies', storeKey: 'spatialStrategies' },
].map(storeItem => ({ ...storeItem, id: string.sluggify(storeItem.label) }));

const storeItemIds = storeItems.map(storeItem => storeItem.id);

const {
  totalWords,
  updateCount,
} = useTinyMCEWordCount(wordLimit, storeItemIds);

const handleWordCountUpdate = ({ id, count }) => {
  updateCount(id, count);
};
</script>
